import { Link } from "react-router-dom";
import { mangaWorks } from "@/mocks/manga";

export default function Topic() {
  const topicWork = mangaWorks.find((w) => w.id === "snow-woman-long-night")!;
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="relative overflow-hidden rounded-xl">
        <img
          src={topicWork.cover}
          alt="雪女传说 冬日漫画 专题背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/75 to-background-950/30"></div>
        <div className="relative z-10 mx-auto max-w-3xl px-6 py-16 md:py-24">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-500/50 bg-accent-500/10 px-4 py-1.5 text-sm text-accent-500">
            <i className="ri-ghost-line"></i> 本期专题 · 雪女传说
          </span>
          <h2 className="mt-5 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
            冷艳雪女，藏着最暖的人心
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-300 md:text-base">
            从《雪女的长夜》到《雪女的盛夏》，我们为你整理了最动人的雪女漫画。传说里她是夺命的山中妖物，而在这些故事里，她只是害怕孤独、渴望被理解的灵魂。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/category/xuenv"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
            >
              进入雪女专题 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to={`/work/${topicWork.id}`}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300/40 bg-background-950/40 px-6 py-3 text-sm font-semibold text-foreground-950 backdrop-blur-sm transition-colors hover:bg-background-950/70"
            >
              <i className="ri-book-open-line"></i> 阅读《{topicWork.title}》
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}